var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[(_vm.apiStateLoading)?_c('Splash'):_vm._e(),(_vm.apiStateError)?_c('Error'):_vm._e(),(_vm.apiStateLoaded || !_vm.isAuthenticatedRoute)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }